

  const ImagePath = (path:any) => {
    return require(`./${path}`);
  };


  export {ImagePath};